import { InjectionToken } from '@angular/core';

function resolveApiBaseUrl(): string {
  if (typeof window === 'undefined') {
    return 'http://localhost:3001';
  }

  const configuredApiBase = (
    window as Window & { __env?: { API_BASE?: string } }
  ).__env?.API_BASE?.trim();
  if (configuredApiBase && !configuredApiBase.includes('${')) {
    return configuredApiBase.replace(/\/$/, '');
  }

  const { protocol, hostname, port } = window.location;
  // Local Angular dev servers: bypass nginx and hit NestJS directly
  if (port === '4200' || port === '8080' || port === '3001') {
    return `${protocol}//${hostname}:3001`;
  }

  // Docker / nginx (port 80 or 443): use current origin; nginx proxies /api/
  return window.location.origin;
}

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL', {
  factory: resolveApiBaseUrl,
});
